import categoryStore from '../../store/store';
import { action } from 'satcheljs/lib/legacy';

/**
 * Resets NewCategoryViewState
 */
export default action('NewCategoryViewState')(function NewCategoryViewState() {
    categoryStore.categoryMenuViewState.newCategoryViewState = null;
    categoryStore.categoryColorPickerViewState = {
        shouldShowColorPicker: false,
        colorPickerTarget: null,
    };
});
